import { isEmpty } from 'lodash';

class WeatherStore {

  constructor() {
    this.bindActions(this.alt.getActions('Weather'));

    this.wsi = {};
    this.errors = {};
  }

  onReadWsiSuccess(data) {
    if (isEmpty(this.wsi)) {
      this.wsi = data;
      delete this.errors['readWsi'];
    }
  }

  onReadWsiFail({ error }) {
    this.errors['readWsi'] = error;
  }

  onUpdateWsiSuccess(data) {
    this.wsi['data'] = data;
    delete this.errors['readWsi'];
  }
}

export default WeatherStore;



// WEBPACK FOOTER //
// ./app/flux/stores/Weather.js